<img [alt]="alt"
  width="80"
  height="80"
  class="w-20 h-20 rounded-tl print:rounded print:w-10 print:h-10"
  [src]="src" />